<div class="grid nested-grid">
  <div class="col-12">
    <app-toolbar #v2toolbar [sidebarVisible]="sidebarVisible" (setSelectedDriver)="onDriverSelected($event)"
      (orderAssigned)="onOrderDragged($event)" (onStatusChanged)="onDriverStatusSelected($event)"
      (sidebarStateChange)="onSidebarStateChanged($event)"
      (orderUnassigned)="onUnassignOrder()">
    </app-toolbar>
  </div>
  <div class="flex col-12">
    <div class="flex-grow-1 mr-2">
      <p-scrollPanel class="custom-scroll-panel" [style]="{ width: '100%', height: '80vh' }">
        <div *ngIf="!getDisplayedDrivers().length"
          class="flex flex-column align-items-center justify-content-center p-4">
          <i class="pi pi-users text-5xl text-gray-400 mb-3"></i>
          <span class="text-gray-600">No drivers found with this status</span>
        </div>
        <div class="grid">
          <div class="col-12" *ngFor="let card of getDisplayedDrivers()">

            <p-card class="mb-4" [ngClass]="{'drop-highlight': draggedOver === card.driver.driver_id}">
              <div class="flex">
                <!-- Left Section: Driver Details -->
                <div class="flex-none w-3">
                  <div class="flex justify-content-between align-items-center mb-2">
                    <h3 class="text-xl font-bold m-0">{{card.driver.first_name}} {{card.driver.last_name}}</h3>
                    <div class="flex align-items-center gap-2 pl-3">
                      <p-checkbox [disabled]="!hasAccess"
                        [ngModel]="card.dailyDispatch.daily_driver_status !== 'Available'" [binary]="true"
                        (onChange)="updateAvailability(card.driver.driver_id, $event)">
                      </p-checkbox>
                      <label>Unavailable</label>
                    </div>
                  </div>
                  <!-- Notes Section -->
                  <div class="flex flex-column gap-2">
                    <h4 class="text-sm font-bold m-0">
                      <a class="text-primary hover:text-primary-700 cursor-pointer"
                        (click)="equipmentEditDialog.editTruck(card.driver.driver_id)">{{equipmentEditDialog.getTruckNumber(card.driver.driver_id)}}</a>
                      -
                      <a class="text-primary hover:text-primary-700 cursor-pointer"
                        (click)="equipmentEditDialog.editTrailer(card.driver.driver_id)">{{equipmentEditDialog.getTrailerNum(card.driver.driver_id)}}</a>
                    </h4>
                    <!-- <h4 class="text-sm font-bold m-0">({{getTrailerNumber(card.driver.trailer_id)}})</h4> -->
                    <div class="flex align-items-center gap-2">
                      <span class="block mb-2 text-base">Notes:</span>
                      <!-- Add warning message when note is required -->
                    </div>
                    <textarea [disabled]="!hasAccess" pInputTextarea [(ngModel)]="card.dailyDispatch.notes" [rows]="5"
                      [autoResize]="true" [ngClass]="{
                        'border-red-500 border-2': card.dailyDispatch.daily_driver_status !== 'Available' && !card.dailyDispatch.notes
                      }" [placeholder]="card.dailyDispatch.daily_driver_status !== 'Available' && !card.dailyDispatch.notes ? 
                        '*Required when driver is unavailable' : ''" class="w-full bg-black-alpha-10"
                      (blur)="updateDailyDispatchWithValue(card.driver.driver_id, $event)"
                      (dragover)="$event.preventDefault()" (drop)="$event.preventDefault()">
                    </textarea>
                  </div>

                  <!-- Dispatch Button -->
                  <div *ngIf="hasAccess" class="flex justify-content-center mt-3">
                    <p-button label="Dispatch" [text]="true" [raised]="true" severity="help"
                      [disabled]="card.dailyDispatch.daily_driver_status !== 'Available'"
                      (onClick)="openSendDispatchDialog(card)">
                      <i class="pi pi-send pr-2"></i>
                    </p-button>
                  </div>
                </div>

                <!-- Vertical Divider -->
                <p-divider layout="vertical"></p-divider>

                <!-- Right Section: Orders -->
                <div class="flex-1 pl-2 drop-zone" pDroppable="orders" (onDrop)="onDrop(card, draggedDriver)">
                  <div class="flex flex-column gap-1">
                    <!-- Orders List -->
                    <div *ngFor="let order of getSortedDispatchOrders(card.dispatchOrders)"
                      class="p-4 border-round-xl relative w-full shadow-1 hover:shadow-3 transition-all transition-duration-300 mb-2"
                      [class.cursor-move]="!isOrderCancelled(order.order_id)"
                      [class.cursor-not-allowed]="isOrderCancelled(order.order_id)"
                      [style]="{
                           'border-left': '4px solid ' + (isOrderCancelled(order.order_id) ? 'var(--red-500)' : 'var(--primary-500)'),
                           'transform-origin': 'center left',
                           'background-color': 'var(--surface-100)',
                           'opacity': isOrderCancelled(order.order_id) ? '0.6' : '1'
                         }" 
                      [pDraggable]="isOrderCancelled(order.order_id) ? undefined : 'orders'"
                      (onDragStart)="onLoadDragStart(order, card)"
                      (onDragEnd)="onLoadDragEnd()">

                      <!-- Null Order Display (Misc Tasks) -->
                      <div *ngIf="order.order_id == null"
                        class="flex justify-content-between align-items-center mb-2 cursor-move" pDraggable="orders"
                        (onDragStart)="onLoadDragStart(order, card)" (onDragEnd)="onLoadDragEnd()">
                        <div class="flex align-items-center gap-6" style="width: 100%;">
                          <!-- Text Area -->
                          <div style="width: 50%;">
                            <textarea pInputTextarea [(ngModel)]="order.notes" [rows]="5" [autoResize]="true"
                              class="w-full bg-black-alpha-10"
                              (focus)="onMiscNotesFocus(order)"
                              (blur)="saveMiscTaskEdit(order, card)"></textarea>
                          </div>

                          <!-- Time Section -->
                          <div class="flex flex-column justify-content-center align-items-center gap-1">
                            <span class="text-sm text-500">Time</span>
                            <span class="cursor-pointer hover:underline font-semibold"
                              (click)="miscTaskDialog.openEditMiscTime(order, card.driver.driver_id)">
                              {{order.scheduled_time ? toCentralTime(order.scheduled_time) : 'No time set'}}
                            </span>
                          </div>
                        </div>
                        <p-button class="pr-2" icon="pi pi-trash" [rounded]="true" severity="danger" raised="true"
                          [outlined]="true" (click)="confirmRemove($event, order, card)" severity="danger"
                          [outlined]="true"></p-button>
                      </div>

                      <!-- Regular Order Display -->
                      <div *ngIf="order.order_id != null && getOrderDetails(order.order_id) as orderInfo">
                        <div class="flex justify-content-between align-items-center">
                          <div *ngIf="orderInfo.supplier_id" class="flex flex-column gap-2">
                            <span class="text-sm font-medium text-600">Shipper</span>
                            <span
                              class="font-semibold text-900 cursor-pointer transition-colors transition-duration-200 hover:text-blue-600 hover:underline"
                              [pTooltip]="getSupplierAddressTooltip(orderInfo)" 
                              tooltipPosition="top"
                              (click)="navigateToCustomer(orderInfo, 'supplier')">
                              {{getCustomerName(orderInfo.supplier_id)}}
                            </span>
                            <span class="text-sm font-medium text-600">Receiver</span>
                            <span
                              class="font-semibold text-900 cursor-pointer transition-colors transition-duration-200 hover:text-blue-600 hover:underline"
                              [pTooltip]="getReceiverAddressTooltip(orderInfo)" tooltipPosition="top"
                              (click)="navigateToCustomer(orderInfo, 'receiver')">
                              {{getCustomerName(orderInfo.receiver_id)}}
                            </span>
                          </div>

                          <div *ngIf="orderInfo.pickup_date" class="flex flex-column gap-2">
                            <span class="text-sm font-medium text-600">Appt Time</span>
                            <span class="cursor-pointer hover:underline font-semibold text-900"
                              (click)="timeEditDialog.editTime(card.driver.driver_id, orderInfo.order_id, 'pickup')">{{toCentralDateTime(orderInfo.pickup_date)}}</span>
                            <span *ngIf="!orderInfo.pickup_date"
                              class="cursor-pointer hover:underline font-semibold text-900"
                              (click)="timeEditDialog.editTime(card.driver.driver_id, orderInfo.order_id, 'pickup')">Not
                              Scheduled</span>


                            <span class="text-sm font-medium text-600">Delivery Time</span>
                            <span *ngIf="orderInfo.delivery_date"
                              class="cursor-pointer hover:underline font-semibold text-900"
                              (click)="timeEditDialog.editTime(card.driver.driver_id, orderInfo.order_id, 'delivery')">{{toCentralDateTime(orderInfo.delivery_date)}}</span>
                            <span *ngIf="!orderInfo.delivery_date"
                              class="cursor-pointer hover:underline font-semibold text-900"
                              (click)="timeEditDialog.editTime(card.driver.driver_id, orderInfo.order_id, 'delivery')">Not
                              Scheduled</span>
                          </div>

                          <div class="flex flex-column gap-2">
                            <span class="text-sm font-medium text-600">Trailer</span>
                            <span class="font-semibold text-900"
                                  [class.cursor-pointer]="hasAccess"
                                  [class.hover:underline]="hasAccess"
                                  (click)="openTrailerEdit($event, orderInfo)">
                              {{orderInfo.trailer_id ? getTrailerNumber(orderInfo.trailer_id) :
                              (orderInfo.external_trailer_number ? orderInfo.external_trailer_number : 'None
                              Assigned')}}
                            </span>
                            <ng-container *ngIf="orderInfo.pickup_number">
                              <span class="text-sm font-medium text-600">Pickup #</span>
                              <span class="font-semibold text-900">{{orderInfo.pickup_number}}</span>
                            </ng-container>
                          </div>

                          <div class="flex flex-column align-items-center gap-4">
                            <i *ngIf="orderInfo.notes" class="pi pi-comment text-primary-500 cursor-pointer text-xl"
                              pTooltip="{{orderInfo.notes}}" tooltipPosition="top">
                            </i>
                            <!-- Split Load Indicator -->
                            <i *ngIf="orderInfo.pickup_driver_id !== orderInfo.delivery_driver_id"
                              class="pi pi-share-alt text-yellow-600 text-lg cursor-pointer"
                              [pTooltip]="getSplitLoadTooltip(orderInfo, card.driver)" tooltipPosition="bottom">
                            </i>
                          </div>

                          <div class="flex align-items-center gap-3">
                            <button pButton [disabled]="!hasAccess || isOrderCancelled(orderInfo.order_id)" [raised]="true" [pTooltip]="'Update Status'"
                              tooltipPosition="top" class="p-button-outlined" [ngClass]="{
            'p-button-info': orderInfo.load_status === 'Scheduled',
            'p-button-danger': orderInfo.load_status === 'Cancelled',
            'p-button-success': orderInfo.load_status === 'Delivered',
            'p-button-warning': ['Loaded'].includes(orderInfo.load_status)
          }" [label]="orderInfo.load_status" [style]="{'border-radius': '4px', 'font-size': '14px'}"
                              (click)="statusUpdateDialog.openStatusNotes(card.driver.driver_id, orderInfo.order_id)">
                            </button>

                            <app-speed-dial-items [card]="card" [orderInfo]="order" [driverCards]="driverCards"
                              [truckContact]="truckContactForCard(card)" [selectedDate]="selectedDate"
                              (notesSaved)="onNotesSaved($event)">
                            </app-speed-dial-items>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Empty state -->
                    <div *ngIf="getSortedDispatchOrders(card.dispatchOrders).length == 0"
                      class="p-3 border-round-lg surface-50 text-center">
                      No loads assigned
                    </div>
                    <div *ngIf="dispatchSidebarOpen && hasAccess"
                      class="card flex align-content-center justify-content-center p-2">
                      <p-button icon="pi pi-plus" [rounded]="true" [text]="true" [raised]="true" size="small"
                        pTooltip="Assign Miscellaneous Task" (onClick)="openMiscDialog(card.driver.driver_id)" />
                    </div>
                  </div>
                </div>
              </div>
            </p-card>
          </div>
        </div>
      </p-scrollPanel>
    </div>

    <div class="">
      <p-scrollPanel class="custom-scroll-panel" [style]="{ width: '100%', height: '80vh' }">
        <div class="flex flex-column gap-2" style="width: 330px">
          <div class="surface-card border-round-xl p-4 flex flex-column gap-4">
            <app-load-logistics></app-load-logistics>
          </div>

          <div class="surface-card border-round-xl p-4 flex flex-column gap-4" style="min-height: 80vh">
            <app-trailer-tracker #trailertracker [driverCards]="driverCards" [trailers]="trailers" [orders]="allOrders"
              [customers]="customers" [drivers]="drivers" [selectedDate]="selectedDate"></app-trailer-tracker>
          </div>
        </div>
      </p-scrollPanel>
    </div>
  </div>


  <p-confirmDialog #confirmDialog>
    <ng-template pTemplate="headless" let-message>
      <div class="flex flex-column align-items-center p-5 surface-overlay border-round">
        <div>
          <i class="pi pi-exclamation-triangle text-2xl"></i>
        </div>
        <span class="font-bold text-2xl block mb-2 mt-2">
          {{ message.header }}
        </span>
        <p class="mb-0">{{ message.message }}</p>
        <div class="flex align-items-center gap-2 mt-4">
          <button pButton label="No" (click)="confirmDialog.reject()" class="p-button-text w-8rem ">
          </button>
          <button pButton label="Yes" (click)="confirmDialog.accept()" class="p-button-outlined w-8rem"
            severity="success">
          </button>
        </div>
      </div>
    </ng-template>
  </p-confirmDialog>
</div>

<app-status-update-dialog #statusUpdateDialog [driverCards]="driverCards" [allOrders]="allOrders"
  [selectedDriverDispatch]="selectedDriverDispatch" [selectedOrderId]="selectedOrderId"
  [saltTypeDialog]="saltTypeDialog" (openWashoutDialog)="openWashoutDialog($event)">
</app-status-update-dialog>

<app-washout-dialog #washoutDialog [allOrders]="allOrders" [selectedOrderId]="selectedOrderId" [trailers]="trailers">
</app-washout-dialog>


<app-misc-task-dialog #miscTaskDialog [driverCards]="driverCards" [selectedDriverDispatch]="selectedDriverDispatch"
  [selectedOrder]="selectedOrder" [trailers]="trailers">
</app-misc-task-dialog>

<app-assign-to-new-order-dialog #assignToNewOrderDialog [driverCards]="driverCards"
  [selectedDriverDispatch]="selectedDriverDispatch" [selectedOrder]="selectedOrder" [trailers]="trailers">
</app-assign-to-new-order-dialog>


<!-- Hidden assign-equipment component for handling truck/trailer assignments -->
<app-assign-equipment #equipmentAssigner style="display: none;"></app-assign-equipment>



<app-salt-type-dialog #saltTypeDialog [trailers]="trailers" [allOrders]="allOrders">
</app-salt-type-dialog>


<!-- Send Dispatch Dialog -->
<app-send-dispatch #dispatchDialog></app-send-dispatch>

<!-- Time Edit Dialog -->
<app-time-edit-dialog #timeEditDialog [selectedOrder]="selectedOrder" [selectedDriverDispatch]="selectedDriverDispatch"
  [drivers]="drivers" [orders]="allOrders" [selectedDate]="selectedDate">
</app-time-edit-dialog>


<!-- Equipment Edit Dialog -->
<app-equipment-edit-dialog #equipmentEditDialog [trailers]="trailers" [trucks]="trucks" [drivers]="drivers"
  [driverCards]="driverCards">
</app-equipment-edit-dialog>

<!-- Inline Trailer Edit Overlay -->
<p-overlayPanel #trailerOverlay [style]="{ 'min-width': '240px' }">
  <div class="flex flex-column gap-3 p-1">
    <span class="font-semibold text-sm">Edit Trailer</span>
    <p-autoComplete
      [(ngModel)]="trailerEditValue"
      [suggestions]="trailerSuggestions"
      (completeMethod)="filterTrailerSuggestions($event)"
      [forceSelection]="false"
      [style]="{ width: '100%' }"
      inputStyleClass="w-full"
      placeholder="Type trailer number">
    </p-autoComplete>
    <div class="flex justify-content-end gap-2">
      <p-button label="Cancel" styleClass="p-button-text p-button-sm"
                (onClick)="trailerOverlay.hide()">
      </p-button>
      <p-button label="Save" styleClass="p-button-sm"
                (onClick)="saveTrailerEdit()">
      </p-button>
    </div>
  </div>
</p-overlayPanel>